/*-----------------------------------------------------------------
- Dashboard
-----------------------------------------------------------------*/

export default {
    title: 'حساب کاربری',

    sidebar: {
        charge_wallet: 'افزایش اعتبار',
    },

    nav: {
        profile        : 'اطلاعات فردی',
        orders         : 'سفارش‌های من',
        transactions   : 'تراکنش‌های من',
        addresses      : 'لیست آدرس‌ها',
        wishlist       : 'لیست علاقه‌مندی‌ها',
        change_password: 'تغییر رمز عبور',
        logout         : 'خروج از حساب کاربری',
    },

    user_info: {
        name_full  : 'نام و نام خانوادگی',
        mobile     : 'شماره همراه',
        tel        : 'تلفن',
        gender     : 'جنسیت',
        email      : 'ایمیل',
        code_melli : 'کد ملی',
        address    : 'آدرس',
        postal_code: 'کدپستی',
        birth_at   : 'تاریخ تولد',
        biography  : 'بیوگرافی',
    },

    gender: {
        male        : 'مرد',
        female      : 'زن',
        not_selected: 'تکمیل نشده',
    },

    profile: {
        title: 'اطلاعات فردی',
    },

    change_password: {
        title: 'تغییر رمز عبور',
    },

    // TODO: Separated this locales
    resources: {
        tracking_number: 'کد پیگیری',
        back_track_no  : 'کد پیگیری بانک',
        datetime       : 'تاریخ و ساعت',
        date           : 'تاریخ',
        time           : 'ساعت',
        price          : 'مبلغ',
        total_price    : 'مبلغ کل',
        shipping_price : 'هزینه ارسال',
        sum_price      : 'جمع مبلغ',
        comments       : 'توضیحات',
        status         : 'وضعیت',
        order_number   : 'شماره سفارش',
    },

    orders: {
        title: 'سفارش‌های من',
        table: {
            order_number: 'شماره سفارش',
            date        : 'تاریخ',
            time        : 'ساعت',
            status      : 'وضعیت',
            price       : 'مبلغ کل',
            details     : 'جزئیات',
        },
        filters: {
            all  : 'همه سفارش‌ها',
            open : 'سفارش‌های جاری',
            close: 'سفارش‌های تکمیل شده',
        },
        details: {
            title       : 'جزئیات سفارش',
            transactions: 'جزئیات تراکنش‌',
        },
    },

    transactions: {
        title: 'تراکنش‌های من',
        table: {
            tracking_number: 'کد پیگیری',
            back_track_no  : 'کد پیگیری بانک',
            date           : 'تاریخ و ساعت',
            price          : 'مبلغ',
            comments       : 'توضیحات',
            status         : 'وضعیت',
        },
        filters: {
            all     : 'همه تراکنش‌ها',
            paid    : 'پرداختی',
            received: 'واریزی',
        },
    },

    wishlist: {
        title: 'لیست علاقه‌مندی‌ها',
        table: {
            title: 'مشخصات محصول',
            price: 'قیمت',
        },
        delete    : 'حذف محصول از لیست',
        modal     : 'آیا از حذف محصول از لیست علاقه‌مندی‌ها مطمئن هستید؟',
        delete_msg: 'محصول با موفقیت از لیست علاقه‌مندی‌ها حذف شد.',
    },

    wallet: {
        charge: {
            title       : 'افزایش اعتبار',
            description : 'با شارژ موجودی حساب خود می‌توانید با سرعت و سهولت بیشتری خرید کنید.',
            credit      : 'موجودی کیف پول',
            select_gates: 'درگاه بانکی خود را انتخاب کنید:',
            button      : 'افزایش اعتبار',
            input       : {
                label      : 'مبلغ دلخواه',
                placeholder: 'مبلغ دلخواه خود را وارد کنید.',
            },
            messages: {
                success: 'افزایش اعتبار با موفقیت انجام شد.',
                error  : 'افزایش اعتبار ناموفق بود.',
            },
        },
    },

    address: {
        title   : 'لیست آدرس‌ها',
        resource: {
            postal_code: 'کدپستی',
        },
        no_title: 'بدون عنوان',
        remove  : 'آیا از حذف آدرس خود مطمئن هستید؟',
        buttons : {
            add: 'آدرس جدید',
        },
    },
};
